import {
  address,
  compliance,
  email,
  name,
  phoneNumber,
  sourceOfInformation,
  taxExemptionEligibility,
  taxIdNumber,
  website,
} from './constants'

export const tradeAndWholesaleApplicationJson = [
  name,
  address,
  email,
  phoneNumber,
  website,
  taxExemptionEligibility,
  taxIdNumber,
  sourceOfInformation,
  compliance,
]
